import React from 'react';
import { ui } from '../../../config/uiSizes';

interface SelectedResourceTableButtonsProps {
  totalSelectedCount: number;
  selectedResourceIds: string[];
  openConfirmModal: (type: 'all' | 'current') => void;
}

export const SelectedResourceTableButtons: React.FC<SelectedResourceTableButtonsProps> = ({
  totalSelectedCount,
  // selectedResourceIds,
  openConfirmModal
}) => {
  return (
    <>
      <div className="col-start-1 col-end-4">
          <div className={`flex justify-center ${ui.gap.md}`}>
          <button
            type="button"
            onClick={() => openConfirmModal('all')}
            disabled={totalSelectedCount === 0}
            className={`rounded-lg ${ui.button.md} font-semibold transition ${totalSelectedCount === 0
              ? 'bg-gray-100 dark:bg-gray-700 text-gray-400 cursor-not-allowed'
              : 'bg-red-100 dark:bg-red-700 text-red-700 dark:text-red-200 hover:bg-red-200 dark:hover:bg-red-600'
              }`}
          >
            Clear All Selections
          </button>
        </div>
      </div>
    </>
  );
};

export default SelectedResourceTableButtons;
